/** Data sources whose NgRx cache must be keyed by profile user UUID in the URL. */
export const PROFILE_URL_SCOPED_DATA_SOURCE_KEYS = [
  'profile_user_events',
  'profile_manual_maintenance_minutes',
  'profile_user_ep_wizard',
] as const;

export type ProfileUrlScopedDataSourceKey =
  (typeof PROFILE_URL_SCOPED_DATA_SOURCE_KEYS)[number];

export function isProfileUrlScopedDataSource(
  dataSourceKey: string | null | undefined
): dataSourceKey is ProfileUrlScopedDataSourceKey {
  if (!dataSourceKey) {
    return false;
  }
  return (PROFILE_URL_SCOPED_DATA_SOURCE_KEYS as readonly string[]).includes(
    dataSourceKey
  );
}

export function getCachedDataUserUuid(data: unknown): string | null {
  if (!data || typeof data !== 'object') {
    return null;
  }
  const record = data as Record<string, unknown>;
  if (typeof record['user_uuid'] === 'string') {
    return record['user_uuid'];
  }
  const items = record['items'];
  if (Array.isArray(items) && items.length > 0) {
    const first = items[0];
    if (first && typeof first === 'object' && typeof (first as Record<string, unknown>)['user_uuid'] === 'string') {
      return (first as Record<string, unknown>)['user_uuid'] as string;
    }
  }
  return null;
}
